<template>  
  <!-- View Detail Main Start -->
  <b-modal
    v-model="showModal"
    size="xl"
    scrollable
    title-class="font-18"
    hide-footer
    @hidden="onModalHide"
  >
    <template #modal-header="{ close }">
      <!-- Emulate built in modal header close button action -->
      <h5>
       Supplier | {{ producer_company ? producer_company.producer_name : '' }}
      </h5>
      <div>
      <!-- <button @click="printSupplier($props.supplierdata.id)" target="_blank" >
        <i class="mdi mdi-printer font-size-18"></i>
      </button> -->
      <a v-b-tooltip.hover.v-light :title="trans.get('__JSON__.A4')" :href="config.appurl+'print-supplier/'+base64($props.supplierdata && $props.supplierdata.id)" target="_blank"><i class="mdi mdi-printer font-size-15"></i></a>

      <button @click="close()" class="close">
        <i class="fas fa-times"></i>
      </button>
      </div>
    </template>
        <template>
              <div class="row mt-3 settings-main">
                <div class="col-md-12">
                  <div class="row sections-main">
                    <div class="col-md-3">
                      <h6>
                        {{
                          trans.get("__JSON__.Contact Person")
                        }}
                      </h6>
                      <p>
                        {{$props.supplierdata.contact_person }}
                      </p>
                    </div>
                    <div class="col-md-3">
                      <h6>
                        {{
                          trans.get("__JSON__.Phone Number")
                        }}
                      </h6>
                      <p>
                        {{$props.supplierdata.phone_number }}
                      </p>
                    </div>
                    <div class="col-md-3">
                      <h6>
                        {{
                          trans.get("__JSON__.Email Address")
                        }}
                      </h6>
                      <p>
                        {{$props.supplierdata.email }}
                      </p>
                    </div>
                    <div class="col-md-3">
                      <h6>
                        {{
                          trans.get("__JSON__.Website URL")
                        }}
                      </h6>
                      <p>
                        {{$props.supplierdata.url }}
                        <span
                          class="copy-icon font-size-18"
                          @click="copyToClipboard($props.supplierdata.url, 'urlCopied')"
                        >
                          <i :class="urlCopied ? 'bx bx-check-circle' : 'bx bx-copy-alt'"></i>
                        </span>
                      </p>
                    </div>
                  </div>
                </div>
             </div>
             <div class="row mt-3 settings-main">
                 <div class="col-md-12 mt-3">
                    <div class="row sections-main">
                      <div class="col-md-3">
                        <h6>
                          {{ trans.get("__JSON__.Our Customer Id") }}
                        </h6>
                        <p>{{ $props.supplierdata.customer_id }}
                          <span
                            class="copy-icon font-size-18"
                            @click="copyToClipboard($props.supplierdata.customer_id, 'customerIdCopied')"
                          >
                            <i :class="customerIdCopied ? 'bx bx-check-circle' : 'bx bx-copy-alt'"></i>
                          </span>
                        </p>
                      </div>
                      <div class="col-md-3">
                        <h6>
                          {{ trans.get("__JSON__.Order Until") }}
                        </h6>
                        <p>{{ $props.supplierdata.order_until }}</p>
                      </div>
                      <div class="col-md-3">
                        <h6>
                          {{ trans.get("__JSON__.Delivery Date") }}
                        </h6>
                        <p>{{ $props.supplierdata.delivery_date }}</p>
                      </div>
                      <div class="col-md-3">
                        <h6>
                          {{ trans.get("__JSON__.Order From") }}
                        </h6>
                        <p>{{ $props.supplierdata.order_from }}</p>
                      </div>
                      <div class="col-md-3">
                        <h6>
                          {{ trans.get("__JSON__.UserName") }}
                        </h6>
                        <p>{{ $props.supplierdata.username }}
                          <span
                          class="copy-icon font-size-18"
                          @click="copyToClipboard($props.supplierdata.username, 'usernameCopied')"
                        >
                          <i :class="usernameCopied ? 'bx bx-check-circle' : 'bx bx-copy-alt'"></i>
                        </span>
                        </p>
                      </div>
                      <div class="col-md-3">
                        <h6>
                          {{ trans.get("__JSON__.Password") }}
                        </h6>
                        <p>{{ $props.supplierdata.password }}
                          <span
                          class="copy-icon font-size-18"
                          @click="copyToClipboard($props.supplierdata.password, 'passwordCopied')"
                        >
                          <i :class="passwordCopied ? 'bx bx-check-circle' : 'bx bx-copy-alt'"></i>
                        </span>
                        </p>
                      </div>
                      <div class="col-md-3">
                        <h6>
                          {{ trans.get("__JSON__.Note") }}
                        </h6>
                        <p>{{ $props.supplierdata.note }}</p>
                      </div>
                    </div>
                </div>
              </div>
              <div class="row sections-main" v-if="supplierDetails.supplier_subProduct != ''">
                <div class="col-md-10 mt-3">
                  <h6>Productlist</h6>
                  <table class="table supplier-details">
                    <thead>
                      <th>
                        {{ trans.get("__JSON__.Product Name") }}
                      </th>
                      <th>
                        {{ trans.get("__JSON__.Quntity x Botle size") }}
                      </th>
                      <th>
                        {{ trans.get("__JSON__.Purchase Price without tax") }}
                      </th>
                      <th>
                        {{ trans.get("__JSON__.Purchase Price with tax") }}
                      </th>
                    </thead>
                    <tbody>
                      <tr v-for="(subProduct, index) in supplierDetails.supplier_subProduct" :key="subProduct.sub_product_id + '-' + index">
                        <template v-for="product in products" v-if="product.sub_product_id === subProduct.sub_product_id">
                          <td>{{ product.product_name }} (EAN: {{ product.barcode_number }})</td>
                          <td>{{ product.selling_qty }} x {{ product.att_name }}</td>
                        </template>
                        <td>{{ subProduct.price_excluding_tax }}</td>
                        <td>{{ subProduct.price_including_tax }}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
              <center>
              <div class="row mt-3">
                 <div class="col-md-12 mt-3">
                    <div class="sections-main">
                      <button class="btn btn-danger" type="button" @click="deleteSupplier(base64($props.supplierdata.id))">Delete</button>
                    </div>
                 </div>
              </div>
            </center>
        </template>
       
  </b-modal>
</template>

<script>
import { supplierService } from '../../services';
import config from "../../config";
import { base64,success_message,error_message } from "../../Helper/helper";
export default {
    components : {},  
    props :['supplierdata'],
    data(){
        return {
            config:config,
            orderLoading: false,
            showModal: false,
            supplierDetails: [],
            products:{},
            urlCopied: false,       // Add reactive properties to handle state
            customerIdCopied: false,
            passwordCopied: false,
            usernameCopied: false,
            producer_company:{},
        }
    },
    mounted(){
        this.viewDetails();
        this.preloadProducts();
        this.getProducerCompany();
    },
    methods : {
      async preloadProducts() {
        // Preload the product data
        await this.asyncFindProduct({ search: "" });
      },
      async viewDetails(){
        if (Object.keys(this.products).length === 0) {
          await this.asyncFindProduct({ search: "" });
        }
        this.showModal = true;
        this.orderLoading = true;
        this.supplierDetails = this.$props.supplierdata;
      },
      async asyncFindProduct(query) {
        	this.isLoading = true;
          await supplierService
                .getAllProductByNameApi({ query })
                .then((response) => {
                this.products = response.data.result;
            	  this.isLoading = false;
        	});
    	},
      async getProducerCompany() {
        this.loading = true;
        await supplierService
          .getProducerCompany()
          .then((response) => {
              this.loading = false;
              this.producer_company = response.data.result;

              // Find the matching company
              const matchingCompany = this.producer_company.find(company => company.id === this.supplierdata.producer_company_id);
              
              // Do something with the matching company, e.g., set it to a data property
              if (matchingCompany) {
                this.producer_company = matchingCompany;
              }
        });
      },
      
      modalShow(value){
        this.showModal = value;
        this.$emit("actionChanged");
      },
      onModalHide(){
        this.showModal = false;
        this.$emit('hidden');
      },
      deleteSupplier(id){
          if(confirm("Do you really want to delete?")){
              supplierService.deleteSupplier({id:id})
              .then(response => {
                  if (response.data.code === 200) {
                        this.onModalHide();
                        success_message(response.data.message);
                        this.getSupllier();
                      
                  } else {
                      error_message(response.data.message);
                  }
              });
          }
        },
      printSupplier(id){
        var url = config.appurl +'print-supplier/' +btoa(id);
        var winPrint = window.open(url);
        var fileURL = url
        var fileLink = document.createElement("a");
        fileLink.href = fileURL;
        fileLink.setAttribute("target", '_blank');
        fileLink.click();
        winPrint.print();
      },
      // copyToClipboard(text) {
      //   if (!text) {
      //     return;
      //   }
        
      //   navigator.clipboard.writeText(text).then(() => {
      //     alert('Text copied to clipboard!'); // Show a success message if you have a function for it
      //   })
      // },
      copyToClipboard(text, state) {
        if (!text) {
          return;
        }

        // Reset all copied states
        this.resetCopiedStates();

        if (navigator.clipboard && navigator.clipboard.writeText) {
          navigator.clipboard.writeText(text).then(() => {
            this[state] = true;  // Set the current copied state to true
            setTimeout(() => {
              this[state] = false;  // Reset after a delay (e.g., 2 seconds)
            }, 2000);
          }).catch(err => {
            console.error("Error copying text: ", err);
          });
        } else {
          console.log("Clipboard API not supported. Please manually copy the text.");
        }
      },
      resetCopiedStates() {
        // Reset all copied state variables
        this.urlCopied = false;
        this.customerIdCopied = false;
        this.passwordCopied = false;
        this.usernameCopied = false;
      },
    }
}
</script>

<style>
.supplier-details td {
 background-color: rgb(218, 218, 218);
 border: 1px solid #eff2f7 !important;
 padding : 0.35rem !important;
}
.supplier-details th {
 background-color: rgb(185, 182, 182);
  border: 1px solid #eff2f7 !important;
  padding : 0.35rem !important;
}
.supplier-details tr {
  border: 1px solid #eff2f7 !important;
  padding : 0.35rem !important;
}
.copy-icon{
  background-color: #ededed;
  padding: 4px 4px 2px !important;
  border-radius: 5px;
  margin-left: 5px !important;
}
</style>